import styled from 'styled-components';

export type QATimerControlsTheme = 'dark' | 'light';

interface ThemePalette {
  toggleBg: string;
  toggleColor: string;
  panelBg: string;
  titleColor: string;
  actionBg: string;
  actionHoverBg: string;
  actionColor: string;
}

// theme describes the host app: a dark app gets light-styled controls and vice versa
const PALETTES: Record<QATimerControlsTheme, ThemePalette> = {
  dark: {
    toggleBg: '#f4f5f7',
    toggleColor: '#1e2430',
    panelBg: '#ffffff',
    titleColor: '#8b93a7',
    actionBg: '#eceff4',
    actionHoverBg: '#dde2ea',
    actionColor: '#1e2430',
  },
  light: {
    toggleBg: '#1e2430',
    toggleColor: '#ffffff',
    panelBg: '#1e2430',
    titleColor: '#8b93a7',
    actionBg: '#2d3650',
    actionHoverBg: '#3a4666',
    actionColor: '#ffffff',
  },
};

export const Container = styled.div`
  position: fixed;
  left: 16px;
  bottom: 16px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const Panel = styled.div<{ $theme: QATimerControlsTheme }>`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
  min-width: 160px;
  border-radius: 12px;
  background-color: ${({ $theme }) => PALETTES[$theme].panelBg};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
`;

export const PanelTitle = styled.span<{ $theme: QATimerControlsTheme }>`
  padding: 0 4px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ $theme }) => PALETTES[$theme].titleColor};
`;

export const ActionButton = styled.button<{ $theme: QATimerControlsTheme }>`
  padding: 8px 12px;
  border: none;
  border-radius: 8px;
  background-color: ${({ $theme }) => PALETTES[$theme].actionBg};
  color: ${({ $theme }) => PALETTES[$theme].actionColor};
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${({ $theme }) => PALETTES[$theme].actionHoverBg};
  }
`;

export const ToggleButton = styled.button<{
  $isOpen: boolean;
  $theme: QATimerControlsTheme;
}>`
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 50%;
  background-color: ${({ $isOpen, $theme }) => ($isOpen ? '#e55656' : PALETTES[$theme].toggleBg)};
  color: ${({ $isOpen, $theme }) => ($isOpen ? '#ffffff' : PALETTES[$theme].toggleColor)};
  font-family: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
  transition:
    transform 0.2s ease,
    background-color 0.2s ease;

  &:hover {
    transform: scale(1.08);
  }
`;
